import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const SITE_SURVEYS_LOCATIONANDWALKTHROUGH_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('SITE_SURVEYS_LOCATIONANDWALKTHROUGH');
export const SITE_SURVEYS_LOCATIONANDWALKTHROUGH_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	SITE_SURVEYS_LOCATIONANDWALKTHROUGH_CRUD_ACTION_CONSTANTS
);
